// Config.
import taxData from './taxData';
import theme from './theme';

const taxes = window.taxData || taxData;

const chart = {
  legend: [
    {
      uid: 'reductions',
      swatch: theme.colors.tertiary,
      content: 'My net paycheck reduction',
    },
    {
      uid: 'contributions',
      swatch: theme.colors.secondary,
      content: 'Money I put toward retirement',
    },
    {
      uid: 'savings',
      swatch: theme.colors.primary,
      content: `Account value with ${taxes.interestRate}% annual growth`,
    },
  ],
  options: {
    maintainAspectRatio: false,
    scales: {
      xAxes: [
        {
          ticks: {
            fontColor: theme.colors.default,
          },
        },
      ],
      yAxes: [
        {
          display: false,
        },
      ],
    },
    layout: {
      padding: {
        right: 70,
      },
    },
    hover: [
      {
        animationDuration: 0,
      },
    ],
    tooltips: [
      {
        enabled: false,
      },
    ],
    legend: false,
  },
};

export default chart;



// WEBPACK FOOTER //
// ./src/config/chart.js